import React, { useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import { TransportNavigationHeader } from '../component/transportPriceList/TransportNavigationHeader'
import { TransportPerKmTable } from '../component/transportPriceList/TransportPerKmTable'
import { TransportPerRouteTable } from '../component/transportPriceList/TransportPerRouteTable'
import { TransportPromoTable } from '../component/transportPriceList/TransportPromoTable'

export const TransportPage = () => {
  const [dataSearchFormOne, setDataSearchFormOne] = useState<any>(null)
  const [dataSearchFormTwo, setDataSearchFormTwo] = useState<any>(null)
  const [dataSearchFormThree, setDataSearchFormThree] = useState<any>(null)
  const [getIdSupplier, setIdSupplier] = useState<any>(-1)
  const [refreshPage, setRefreshPage] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [hasSupplierId, setHasSupplierId] = useState<any>(false);
  const [getTenant, setTenant] = useState(null)
  return (
    <>
    <TransportNavigationHeader
    setDataSearchFormOne={setDataSearchFormOne}
    setDataSearchFormTwo={setDataSearchFormTwo}
    setDataSearchFormThree={setDataSearchFormThree}
    getIdSupplier={getIdSupplier}
    setIdSupplier={setIdSupplier}
    refreshPage={refreshPage}
    setRefreshPage={setRefreshPage}
    setOpenDialog={setOpenDialog}
    hasSupplierId={hasSupplierId}
    setHasSupplierId={setHasSupplierId}
    setTenant={setTenant}
    />
      <Routes>
        <Route
          path="/"
          element={
            <TransportPerRouteTable
            dataSearchForm={dataSearchFormOne}
            getIdSupplier={getIdSupplier}
            refreshPage={refreshPage}
            setRefreshPage={setRefreshPage}
            hasSupplierId={hasSupplierId}
            getTenant={getTenant}
            />
          }
        />

        <Route
          path="/pricelist"
          element={
            <TransportPerKmTable
            dataSearchForm={dataSearchFormTwo}
            getIdSupplier={getIdSupplier}
            refreshPage={refreshPage}
            setRefreshPage={setRefreshPage}
            hasSupplierId={hasSupplierId}
            getTenant={getTenant}
            />
          }
        />

        <Route
          path="/promo"
          element={
            <TransportPromoTable
            dataSearchForm={dataSearchFormThree}
            getIdSupplier={getIdSupplier}
            refreshPage={refreshPage}
            setRefreshPage={setRefreshPage}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            hasSupplierId={hasSupplierId}
            getTenant={getTenant}
            />
          }
        />
      </Routes>
      </>
  )
}
